import { leadSubmissionApi } from "./leadSubmissionApi";

export class agentAppointmentDetailApi {
    private props: any;

    private handleAgentAppointmentDetailFromApi: any;

    private handleLeadSubmission: any;

    constructor(local: any, 
        handleAgentAppointmentDetailFromApi: (this: void) => any,
        handleLeadSubmission: (this:void) => any) {
        this.props = local;
        this.handleAgentAppointmentDetailFromApi = handleAgentAppointmentDetailFromApi;
        this.handleLeadSubmission = handleLeadSubmission;
    }

    async GetAgentAppointmentDetail() {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'x-api-key': 'bJx8kYsEFRza88ELBb2Vt8SD2NzXjnPy',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
                "zip": this.props.values.movingFromAddrComponent.MovingFromZip,
                "moveType": this.props.values.isLocalMove ? "L" : "I",
            })
        };
        console.log("Starting AgentAppointment the API Call");
        //Call Instaquote API
        let apiSuccess = false;

        await fetch('/CustomApi/OnlineAppointmentBooking/GetAgentAppointmentDetails', requestOptions)
            .then(response => {
                if (!response.ok) {
                    throw new Error('error => Error while getting Appointment details for agent')
                }
                return response.json();
            })
            .then((data) => {
                console.log("Got Data AgentAppointemtn the API Call");
                if(!data.Success)
                {
                    this.postLeadThruApi();
                }
                this.handleAgentAppointmentDetailFromApi(data);
                apiSuccess = true;
            },
                (error) => {
                    console.log(error);
                    apiSuccess = false;
                })                
            .catch(error => {
                console.log(error)
            });

        return apiSuccess;
    }

    postLeadThruApi() {
        //Submit Lead    
        const leadSubmissionService = new leadSubmissionApi(this.props, this.handleLeadSubmission);
    
        leadSubmissionService.submitLead(false).then((leadSuccess) => {
          if (leadSuccess) {
            console.log("Lead Success");
          }
          else {
            console.log("Lead Failed");
          }
        });
      }
}